import { Stack, Typography, Chip } from "@mui/material";
import useUserData from "../../../hooks/user/useUserData";
import {useTranslation} from "react-i18next";
import {PRODUCT_INFO} from "../../../locales/components/namespaces";

const TOKENS = {
    black: "#111111",
    gray: "#9E9E9E",
    grayPillBg: "#DADADA",
    grayPillText: "#111111",
    badgeYellow: "#F2C94C",
    white: "#FFFFFF",
    stroke: "#EFEFEF",
};

const UI = {
    maxWidthPx: 498,
    titleFs: { xs: 28, md: 30 },
    titleLh: 1.1,
    titleLs: 0.2,
    pillH: 24,
    pillRadius: 999,
    pillFs: 12,
    gapPills: 8,
    mbPills: 1,
    mbCode: 0,
    mbTitle: 1,
    badgeH: 28,
    badgeFs: 12,
};

export default function ProductInfoHeader({ product }) {
    const{language} = useUserData()
    const {t}= useTranslation(PRODUCT_INFO);
    const subcategory = language ==='el'? product?.categoryEL : product?.categoryEN;
    const brand = language ==='el'? product?.brandEL : product?.brandEN;
    const sku = product?.code
    const shortDescription = language ==='en'? product?.shortDescriptionEN : product?.shortDescriptionEL;
    const description = language ==='en'? product?.descriptionEN : product?.descriptionEL;

    const availability = product?.availability;


    return (
        <Stack sx={{ width: "100%", maxWidth: { xs: "100%", md: `${UI.maxWidthPx}px` } }}>

            <Stack
                direction="row"
                sx={{ flexWrap: "wrap", columnGap: `${UI.gapPills}px`, rowGap: `${UI.gapPills}px`, mb: UI.mbPills }}
            >
                <Chip
                    label={subcategory.toUpperCase()}
                    size="small"
                    sx={{
                        height: UI.pillH,
                        borderRadius: UI.pillRadius,
                        bgcolor: TOKENS.grayPillBg,
                        color: TOKENS.grayPillText,
                        border: "none",
                        "& .MuiChip-label": { px: 1.25, pt: 0.1, fontSize: UI.pillFs, fontWeight: 700 },
                    }}
                />
                <Chip
                    label={brand.toUpperCase()}
                    size="small"
                    sx={{
                        height: UI.pillH,
                        borderRadius: UI.pillRadius,
                        bgcolor: TOKENS.grayPillBg,
                        color: TOKENS.grayPillText,
                        border: "none",
                        "& .MuiChip-label": { px: 1.25, pt: 0.1, fontSize: UI.pillFs, fontWeight: 700 },
                    }}
                />
            </Stack>

            {sku && (
                <Typography
                    variant="caption"
                    sx={{ color: TOKENS.gray, letterSpacing: 0.4, textTransform: "uppercase", mb: UI.mbCode }}
                >
                    {t('Code')}: {sku}
                </Typography>
            )}

            {/* Title */}
            <Typography
                component="h1"
                sx={{
                    fontSize: UI.titleFs,
                    lineHeight: UI.titleLh,
                    fontWeight: 800,
                    color: TOKENS.black,
                    letterSpacing: UI.titleLs,
                    textTransform: "uppercase",
                    mb: UI.mbTitle,
                }}
            >
                {language === 'el'? product?.nameEL: product?.nameEN}
            </Typography>
                <Chip
                    label={t(availability.labelKey)}
                    size="small"
                    sx={{
                        width: "fit-content",
                        height: UI.badgeH,
                        borderRadius: UI.pillRadius,
                        bgcolor: availability.color,
                        color: TOKENS.white,
                        fontWeight: 700,
                        "& .MuiChip-label": { px: 1.5, pt: 0.25, fontSize: UI.badgeFs },
                        mb: 1.10,
                    }}
                />


            {!!shortDescription && (
                <Typography variant="body2" sx={{color: TOKENS.black, opacity: 0.8}}>
                    <div dangerouslySetInnerHTML={{__html: shortDescription}}/>
                </Typography>
            )}
        </Stack>
    );
}
